import React, { useState, useEffect, useCallback } from "react";
// Removed react-tabs in favor of custom styled tabs
import { useNavigate } from "react-router-dom";

import MyProfile from "./MyProfile";
import ShopDetails from "./ShopDetails";
import {
  ProfileContainer,
  TabsWrapper,
  TabPanels,
  TabBar,
  TabButton,
  TabPanel,
} from "../../styles/profile";

import {
  ButtonContainer,
  CancelButton,
  NextButton,
} from "../../styles/PersonalInfoStep";
import { GET, POST } from "../../services/HTTPServices";
import {
  alertMessage,
  alertMessageWithCancel,
} from "../../services/alertService";
import { ALERT_TITLES, ROUTES } from "../../constants";
import { setItemWithObject } from "../../utils/cache/LocalStorage";
import {
  LoadingSpinnerIcon,
  LoadingSpinner,
  LoadingOverlay,
} from "../../styles/loading";

const TAB_LIST = [{ label: "My Profile" }, { label: "Shop Details" }];

const Profile = () => {
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [openingHours, setOpeningHours] = useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);

  const [user, setUser] = useState<any>({
    id: 0,
    name: "",
    email: "",
    mobile: "",
    idType: "",
    nricFront: [],
    nricFrontPath: [],
    nricBack: [],
    nricBackPath: [],
    letterOfAuth: [],
    letterOfAuthPath: [],
    digitalCopies: [],
    digitalCopiesPath: [],
    storeCover: [],
    storeCoverPath: [],
    catalogue: [],
    cataloguePath: [],
    shopName: "",
    postcode: "",
    city: "",
    street: "",
    building: "",
    block: "",
    floor: "",
    unit: "",
    latitude: "",
    longitude: "",
    entityName: "",
    uen: "",
    signeeName: "",
    signeeNRIC: "",
    companyName: "",
    registrationNo: "",
    registrationDate: "",
    companyPhone: "",
    companyEmail: "",
    companyAddress: "",
    businessType: "",
    businessActivity: "",
    businessActivity2: "",
    website: "",
    isDeactivate: true,
    isDelete: true,
    createdDate: "",
    createdUserId: "",
    updatedUserId: "",
    serviceProviderServices: [],
  });

  const getOpeningHours = useCallback(async (id: any) => {
    let res: any = await GET(
      "openinghour/GetOpeningHour?spId=" + id,
      "provider"
    );
    if (res && res.data) {
      setOpeningHours(res.data);
      setLoading(false);
    } else setLoading(false);
  }, []);

  const getUser = useCallback(
    async (id: any) => {
      try {
        const res: any = await GET(
          `serviceprovider/GetServiceProviderById?id=${id}`,
          "provider"
        );
        if (res && res.data) {
          const fetchedData = res.data;
          const phone = fetchedData.mobile?.split("+65");
          fetchedData.mobile = (phone && phone[1]) || "";
          setUser(fetchedData);
          getOpeningHours(fetchedData.id);
          setItemWithObject("files", fetchedData);
          setItemWithObject("files-user", fetchedData);
        } else {
          handleLogout();
        }
      } catch (error) {
        console.error("Failed to fetch user:", error);
        handleLogout();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate]
  );

  const handleLogout = async () => {
    Object.keys(localStorage)
      .filter((k) => k !== "login_credentials")
      .forEach((k) => localStorage.removeItem(k));
    navigate(ROUTES.LOGIN);
  };

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      if (authUser.userType !== 2) {
        handleLogout();
        return;
      }
      getUser(authUser.id);
    } else {
      handleLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
;

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      if (authUser.userType !== 2) {
        handleLogout();
      }
    } else {
      handleLogout();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleChange = (field: string, value: any) => {
    if (field === "openingHours") {
      setOpeningHours(value);
    } else
      setUser((prev: any) => ({
        ...prev,
        [field]: value,
      }));
  };

  const preCancel = async () => {
    const confirmLeave = await alertMessageWithCancel(
      ALERT_TITLES.INFO,
      "Are you sure to cancel?"
    );
    if (confirmLeave) cancel();
  };

  const cancel = () => {
    setLoading(true);
    getUser(user.id);
  };

  const valid = () => {

    if (
      !user.sfaLicense ||
      user.sfaLicense.length === 0 ||
      !user.storeCover ||
      user.storeCoverPath.length === 0 ||
      !user.storeCoverAR1 ||
      user.storeCoverAR1Path.length === 0 ||
      !user.nricFrontPath ||
      user.nricFrontPath.length === 0 ||
      (user.businessType === "business" &&
        (!user.letterOfAuthPath || user.letterOfAuthPath.length === 0)) ||
      (user.halalLicensePath?.length > 0 &&
        (!user.halalExpire || user.halalExpire === "")) ||
      (user.liquorLicensePath?.length > 0 &&
        (!user.liquorExpire || user.liquorExpire === ""))
    )
      return false;
    else return true;
  };

  const validDate = () => {

    if (
      (user.halalLicensePath?.length > 0 &&
        (!user.halalExpire || user.halalExpire === "")) ||
      (user.liquorLicensePath?.length > 0 &&
        (!user.liquorExpire || user.liquorExpire === ""))
    )
      return false;
    else return true;
  };

  const save = async () => {
    if(!validDate()){
      alertMessage(ALERT_TITLES.WARNING,"Please choose valid Expiry Dates! Expiry date must be after today.")
    }else{
      setLoading(true);
      let tempUser = { ...user };
      tempUser.updatedUserId = user.id.toString();
      tempUser.mobile = "+65" + tempUser.mobile;

      let url = "serviceprovider/UpdateServiceProvider";
      let res: any = await POST(url, tempUser, "provider");

      if (res && res.status === 200) {
        saveOpeningHours(user.id);

        setLoading(false);
      } else {
        setLoading(false);
        if (res.status && res.status === 401) {
          navigate("/unauthorized-page");
        } else {
          alertMessage(ALERT_TITLES.ERROR, res.message);
        }
      }
      
    }
    
  };

  const saveOpeningHours = async (id : any) => {
    let url = "openinghour/UpdateOpeningHour";
    let res: any = await POST(url, openingHours, "provider");

    if (res && res.status === 200) {
      getCheckList(id)
    } else {
      setLoading(false);
      if (res.status && res.status === 401) {
        navigate("/unauthorized-page");
      } else {
        alertMessage(ALERT_TITLES.ERROR, res.message);
      }
    }
  };

   const getCheckList = async (id: any) => {
      const res: any = await GET(
        "onboardingcheck/GetOnboardingCheckBySpId?spId=" + id,
        "provider"
      );
      if (res && res.data) {
        postChecklist(res.data[0])
      }
    };

  const postChecklist = async (checklist : any) => {
      setLoading(true);
      let url = "onboardingcheck/UpdateOnboardingCheck";
  
      let temp = {
        serviceProviderId: checklist.serviceProviderId,
        personalInfo: checklist.personalInfo,
        businessInfo: checklist.businessInfo,
        kyb: checklist.kyb,
        fileUpload: !valid() ? 0 : 1,
        agreement: checklist.agreement,
      };
  
      let res: any = await POST(url, temp, "provider");
  
      if (res && res.status === 200) {
        alertMessage(
        ALERT_TITLES.SUCCESS,
        "You updated information successfully,"
      );
      getUser(checklist.serviceProviderId)
      setLoading(false);
      } else {
        setLoading(false);
        if (res.status && res.status === 401) navigate("/unauthorized-page");
        else {
          alertMessage(ALERT_TITLES.ERROR, res.message);
        }
      }
    };

  const renderView = () => (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <ProfileContainer>
        <TabsWrapper>
          <TabBar role="tablist">
            {TAB_LIST.map((tab, idx) => (
              <TabButton
                key={tab.label}
                role="tab"
                aria-selected={tabIndex === idx}
                tabIndex={tabIndex === idx ? 0 : -1}
                $active={tabIndex === idx}
                onClick={() => setTabIndex(idx)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setTabIndex(idx);
                  }
                }}
              >
                {tab.label}
              </TabButton>
            ))}
          </TabBar>
          <TabPanels>
            <TabPanel $active={tabIndex === 0}>
              <MyProfile formData={user} onChange={handleChange} />
            </TabPanel>
            <TabPanel $active={tabIndex === 1}>
              <ShopDetails
                formData={user}
                openingHours={openingHours}
                onChange={handleChange}
              />
            </TabPanel>
          </TabPanels>
        </TabsWrapper>
        <ButtonContainer>
          <CancelButton type="button" onClick={preCancel} className="mr-8">
            Cancel
          </CancelButton>
          <NextButton type="button" onClick={save}>
            Save
          </NextButton>
        </ButtonContainer>
      </ProfileContainer>
    </>
  );

  return renderView();
};

export default Profile;
